//package import 
import React, { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

//component import 
import { CusotomSearch } from "../../utils/resuableComponents/CustomSearch";
import { showToast } from "../../utils/constants/Toaster";
import { ShareManagementHeading, ShareReportHeading,  UserDepetailsPath,NoDataToExportMessage } from "../../utils/TextInputUtils";
import { columnsShareReportData } from "../../utils/constants/TableHeader";
import { getSharesList, getStateList } from "../../services/apiServices/GetServices";
import { ReportsFilter } from "../../utils/resuableComponents/ShareReportsFilter";
import { createShare, getAdminReport } from "../../services/apiServices/PostServices";
import Modal from 'react-bootstrap/Modal'
import CustomTable from "../../utils/resuableComponents/CustomTable";
import Loader from "../loadingScreens/Loader";


const ShareReports = () => {

    const [isLoader, setIsLoader] = useState(false)
    const [filteredData, setFilteredData] = useState([])
    const [adminReportData, setAdminReportData] = useState()
    const [investmentType, setInvestmentType] = useState([])
    const [stateData, setStatesData] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const [searchFilterApplied,setSearchFilteredApplied]=useState(false)
    const [checkedData, setCheckedData] = useState([])
    const [filtersApplied, setFiltersApplied] = useState()

    const pathName = { UserDepetailsPath } //path to the userdetails navigation

    const removeIdField = (arr) => arr.map(({ id, ...rest }) => rest);
    const exportFileData = removeIdField(filteredData);

    //functoon call to export the filtered data
    const exportToExcel = () => {
        if(filteredData.length === 0){
            showToast(3,NoDataToExportMessage)
        }else{
            const worksheet = XLSX.utils.json_to_sheet(exportFileData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
            // Buffer to store the generated Excel file
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    
            saveAs(blob, "Shares Report.xlsx");
        }
    };

    //use effect function call to call the intial apis
    useEffect(() => {
        getShareList()
        callStateslistApi()
        // callAdminReports()
    }, [])

    //use effect function call to call the admin api intially 
    useEffect(() => {
        if (searchTerm === "") {
            callAdminReports()
        }
    }, [searchTerm])

    //api function call to get the share list
    const getShareList = async () => {
        try {
            const res = await getSharesList("allShare");
            if (res.success) {
                // setFilteredData(res?.shares)
                const filteredData = res?.shares?.filter(data => data?.is_active === 1)
                setInvestmentType(filteredData)
            } else {
                console.log("res", res)
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    //api to call admin report data
    const callAdminReports = async () => {
        setIsLoader(true)
        const req_body = {
            city_id: "",
            state_id: "",
            share_type: "",
            from: "",
            to: "",
            search_key: ""

        }
        try {
            const res = await getAdminReport("adminReport", req_body);
            if (res?.success) {
                setAdminReportData(res?.data)
                setFilteredData(res?.data)
            } else {
                console.log("res", res?.message)
            }

        } catch (error) {
            console.log("error", error)
        }
    }

    //api function call for the search functionality
    const handleSearch = (val) => {
        const searchVal = val
        if (searchVal === "") {
            setSearchTerm(searchVal);
        } else {
            setSearchTerm(searchVal);
        }
    }

    const onClickSeach = () => {
        setSearchFilteredApplied(true)
        handleReqbody()
    }

    //function call to apply the filter and call the api.
    const handleReqbody = async (reqBody) => {
        const req_body = {
            city_id: reqBody?.city_id || "",
            state_id: reqBody?.state_id || "",
            share_type: reqBody?.share_type || "",
            from: reqBody?.from || '',
            to: reqBody?.to || "",
            search_key: searchTerm || ""
        }
        setFiltersApplied(req_body)
        try {
            const res = await getAdminReport("adminReport", req_body);
            if (res?.success) {
                setFilteredData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    //function to call list api
    const callStateslistApi = async () => {
        try {
            const res = await getStateList("state/1")
            if (res?.success) {
                setStatesData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    //function call to clear the search and call the reports api
    const handleClear = () => {
        callAdminReports()
        // setFilterApplied(false)
    }

    return (
        <div className="col-lg-12 d-flex  flex-column">
            {isLoader ? <Loader /> : null}
            <div className="d-flex flex-row justify-content-between align-items-center w-100 border-bottom p-2">
                <h1 className="fs-4 mx-3 ps-1 Montserrat fw-semi-bold">
                    {ShareReportHeading}
                </h1>
                <div className="d-flex flex-row ">
                    <ReportsFilter appliedFilers={filtersApplied} searchFilter={searchFilterApplied} reqBody={handleReqbody} searchVal={searchTerm} clear={handleClear} investmentType={investmentType} stateData={stateData} />
                    {/* <button type="button" class="colorOutline mx-2 px-3" onClick={() => setOpenFilter(true)} >Filter</button> */}
                    <button type="button" class="colorOutline mx-2 px-3" onClick={exportToExcel}  >Export</button>
                </div>
            </div>

            <div className="d-flex justify-content-start">
                <CusotomSearch onChange={handleSearch} />
                <button type="button" class="colorOutline mx-2 my-3 px-3 h-25" onClick={onClickSeach} >Search</button>
            </div>
            {/* <hr className="hr w-100 m-0 my-1" /> */}
            <CustomTable path={pathName} data={filteredData} columnHeader={columnsShareReportData} from="share reports" />
            {/* <h5 className="text-center">No share repots</h5> */}
        </div>
    )
}

export default ShareReports